import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import axios from "../../../../Uri";
import * as Yup from "yup";

export default function ExtenPlanForRegularAndMonthlyAsDaily(props) {
  const [submitError, setSubmitError] = useState("");
  const [submitSuccess, setSubmitSuccess] = useState("");

  useEffect(() => {
    if (!submitSuccess) return;
    const t = setTimeout(() => setSubmitSuccess(""), 6000);
    return () => clearTimeout(t);
  }, [submitSuccess]);

  const styles = {
    container: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      background: "linear-gradient(135deg, #667eea, #764ba2)",
      padding: "20px",
    },
    formCard: {
      position: "relative",
      backgroundColor: "#ffffff",
      padding: "30px",
      borderRadius: "12px",
      width: "100%",
      maxWidth: "420px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    },
    title: {
      textAlign: "center",
      marginBottom: "20px",
      color: "#333",
      fontSize: "22px",
      fontWeight: "600",
    },
    formGroup: {
      marginBottom: "15px",
      display: "flex",
      flexDirection: "column",
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      outline: "none",
      fontSize: "14px",
      boxSizing: "border-box",
    },
    readOnlyInput: {
      backgroundColor: "#f5f5f5",
      cursor: "not-allowed",
    },
    select: {
      width: "100%",
      padding: "10px 12px",
      borderRadius: "8px",
      border: "1px solid #ccc",
      fontSize: "14px",
      backgroundColor: "#fff",
      cursor: "pointer",
    },
    error: {
      color: "red",
      fontSize: "12px",
      marginTop: "4px",
    },
    button: {
      width: "100%",
      padding: "12px",
      backgroundColor: "#667eea",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontSize: "16px",
      cursor: "pointer",
    },
    buttonDisabled: {
      opacity: 0.65,
      cursor: "not-allowed",
    },
    messageSuccess: {
      marginBottom: "16px",
      padding: "12px 14px",
      borderRadius: "8px",
      backgroundColor: "#ecfdf5",
      color: "#047857",
      fontSize: "14px",
      border: "1px solid #6ee7b7",
    },
    messageError: {
      marginBottom: "16px",
      padding: "12px 14px",
      borderRadius: "8px",
      backgroundColor: "#fef2f2",
      color: "#b91c1c",
      fontSize: "14px",
      border: "1px solid #fecaca",
    },
    overlay: {
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(255,255,255,0.82)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "12px",
      zIndex: 10,
      gap: "12px",
    },
    overlayText: {
      fontSize: "15px",
      color: "#4c51bf",
      fontWeight: "600",
    },
    spinner: {
      width: "40px",
      height: "40px",
      border: "4px solid #e0e7ff",
      borderTop: "4px solid #667eea",
      borderRadius: "50%",
      animation: "extPlanSpin 0.75s linear infinite",
    },
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year} 00:00:00`;
  };

  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let userId = userData.data.userId;

  var GuestOccupancyType = props.guestdetails.occupancyType;
  var buildingId = props.guestdetails.buildingId;
  var GuestID = props.guestdetails.id;

  const getResetValues = () => ({
    guestId: GuestID,
    noOfDays: "",
    buildingId: buildingId,
    rentPerDay: "",
    amountPaid: "",
    transactionId: "",
    transactionDate: new Date().toISOString().split("T")[0],
    paymentPurpose: "",
    createdBy: userId,
    occupancyType: GuestOccupancyType,
  });

  const formik = useFormik({
    initialValues: getResetValues(),
    validationSchema: Yup.object({
      guestId: Yup.string().required("Guest ID required"),
      noOfDays: Yup.number().positive().required("Days required"),
      rentPerDay: Yup.number().positive().required("Rent required"),
      transactionId: Yup.string().required("Transaction ID required"),
      paymentPurpose: Yup.string().required("Select purpose"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setSubmitError("");
      setSubmitSuccess("");
      try {
        const formattedDate = formatDate(values.transactionDate);
        const payload = {
          amountPaid: values.amountPaid,
          transactionId: values.transactionId,
          paymentPurpose: values.paymentPurpose,
          transactionDate: formattedDate,
        };

        const url = `/guest/extendPalnAsDailyMonthlyRegular/${GuestID}/${values.noOfDays}`;
        const res = await axios.post(url, payload);

        const msg =
          res.data != null && res.data !== ""
            ? typeof res.data === "string"
              ? res.data
              : JSON.stringify(res.data)
            : "Plan extended successfully.";
        setSubmitSuccess(msg);
        resetForm({ values: getResetValues() });
      } catch (err) {
        const msg =
          err.response?.data?.message ??
          (typeof err.response?.data === "string"
            ? err.response.data
            : err.response?.data
              ? JSON.stringify(err.response.data)
              : null) ??
          err.message ??
          "Something went wrong. Please try again.";
        setSubmitError(String(msg));
      }
    },
  });

  const handleCalculation = (e) => {
    formik.handleChange(e);
    const { name, value } = e.target;
    const rent = name === "rentPerDay" ? value : formik.values.rentPerDay;
    const days = name === "noOfDays" ? value : formik.values.noOfDays;
    if (rent && days) {
      formik.setFieldValue("amountPaid", Number(rent) * Number(days));
    }
  };

  const busy = formik.isSubmitting;

  return (
    <div style={styles.container}>
      <style>{`@keyframes extPlanSpin { to { transform: rotate(360deg); } }`}</style>
      <form style={styles.formCard} onSubmit={formik.handleSubmit} noValidate>
        {busy ? (
          <div style={styles.overlay} aria-live="polite" aria-busy="true">
            <div style={styles.spinner} role="status" />
            <span style={styles.overlayText}>Submitting…</span>
          </div>
        ) : null}

        <h2 style={styles.title}>Payment Details</h2>

        {submitSuccess ? (
          <div style={styles.messageSuccess} role="status">
            {submitSuccess}
          </div>
        ) : null}
        {submitError ? (
          <div style={styles.messageError} role="alert">
            {submitError}
          </div>
        ) : null}

        <div style={styles.formGroup}>
          <input
            style={styles.input}
            name="noOfDays"
            type="number"
            placeholder="No of Days"
            onChange={handleCalculation}
            value={formik.values.noOfDays}
            disabled={busy}
          />
          <p style={styles.error}>{formik.errors.noOfDays}</p>
        </div>

        <div style={styles.formGroup}>
          <input
            style={styles.input}
            name="rentPerDay"
            type="number"
            placeholder="Rent Per Day"
            onChange={handleCalculation}
            value={formik.values.rentPerDay}
            disabled={busy}
          />
          <p style={styles.error}>{formik.errors.rentPerDay}</p>
        </div>

        <div style={styles.formGroup}>
          <input
            style={{ ...styles.input, ...styles.readOnlyInput }}
            name="amountPaid"
            value={formik.values.amountPaid}
            readOnly
            placeholder="Amount Paid"
            disabled={busy}
          />
        </div>

        <div style={styles.formGroup}>
          <input
            style={styles.input}
            name="transactionId"
            placeholder="Transaction ID"
            onChange={formik.handleChange}
            value={formik.values.transactionId}
            disabled={busy}
          />
          <p style={styles.error}>{formik.errors.transactionId}</p>
        </div>

        <div style={styles.formGroup}>
          <input
            style={styles.input}
            name="transactionDate"
            type="date"
            value={formik.values.transactionDate}
            onChange={formik.handleChange}
            disabled={busy}
          />
        </div>

        <div style={styles.formGroup}>
          <select
            style={styles.select}
            name="paymentPurpose"
            onChange={formik.handleChange}
            value={formik.values.paymentPurpose}
            disabled={busy}
          >
            <option value="">Select Purpose</option>
            <option value="Room Rent">Room Rent</option>
            <option value="Check-out Clearance">Check-out Clearance</option>
            <option value="Plan Extension">Plan Extension</option>
          </select>
          <p style={styles.error}>{formik.errors.paymentPurpose}</p>
        </div>

        <button
          type="submit"
          style={{
            ...styles.button,
            ...(busy ? styles.buttonDisabled : {}),
          }}
          disabled={busy}
          onMouseOver={(e) => {
            if (!busy) e.target.style.background = "#5a67d8";
          }}
          onMouseOut={(e) => {
            if (!busy) e.target.style.background = "#667eea";
          }}
        >
          {busy ? "Submitting…" : "Submit"}
        </button>
      </form>
    </div>
  );
}
